<div class="default-cards" *ngIf="dataSource.connect() | async as data">
    <div class="cards-card" *ngFor="let item of data" (click)="onViewClick(item)">
        <div class="card-item card-status">
            <div class="item-status" [ngClass]="'status-' + getStatus(item)?.toLowerCase()">
                {{ 'OVERVIEW.TABLE.OFFER_STATUS.' + getStatus(item) | translate }}
            </div>
        </div>
        <div class="card-item card-vgp">
            <img
                *ngIf="isViGuidePlanning(item)"
                src="/assets/icons/viguideplanning.png"
                [matTooltip]="'OVERVIEW.TABLE.COLUMN.VI_GUIDE_PLANNING.TOOLTIP' | translate"
            />
        </div>
        <div class="card-item">
            <div class="item-description">
                {{ 'OVERVIEW.TABLE.COLUMN.OFFER_NUMBER' | translate }}
            </div>
            {{ item.quoteId }}
        </div>
        <div class="card-item">
            <div class="item-description">
                {{ 'OVERVIEW.TABLE.COLUMN.NAME' | translate }}
            </div>
            {{ item.customerPurchaseNumber }}
        </div>
        <div class="card-item">
            <div class="item-description">
                {{ 'OVERVIEW.TABLE.COLUMN.SCHEME' | translate }}
            </div>
            @if (isNew(item) || !item.scheme) {
            <span>-</span>
            } @else {
            <a
                [href]="item.scheme?.url"
                target="_blank"
                (mouseenter)="onImageHover($event, item)"
                (mousemove)="onImageHover($event, item)"
                (mouseleave)="onImageHover($event, item)"
                (click)="$event.stopPropagation()"
            >
                {{ item.scheme?.id }}
            </a>
            }
        </div>
        <div class="card-item">
            <div class="item-description">
                {{ 'OVERVIEW.TABLE.COLUMN.CREATED_AT' | translate }}
            </div>
            {{ item.createdDate | dateFormat : 'dotDate' }}
        </div>
        <div class="card-item">
            <div class="item-description">
                {{ 'OVERVIEW.TABLE.COLUMN.CREATOR' | translate }}
            </div>
            {{ item.authorName }}
        </div>
        <div class="card-item">
            <div class="item-description">
                {{ 'OVERVIEW.TABLE.COLUMN.TOTAL_GROSS' | translate }}
            </div>
            <span *ngIf="!item.totalGross">-</span>
            <span
                class="item-total-gross"
                *ngIf="item.totalGross"
                (mouseenter)="handlePriceSummaryEvent($event, item)"
                (mouseleave)="handlePriceSummaryEvent($event, item)"
                (mousemove)="handlePriceSummaryEvent($event, item)"
            >
                {{ item.totalGross | currency : item.currency : 'symbol-narrow' }}
            </span>
        </div>
        <div class="card-item card-toolbar">
            <button mat-icon-button color="primary" (click)="onCopyClick(item); $event.stopPropagation()">
                <mat-icon class="material-icons-outlined">content_copy</mat-icon>
            </button>
            <button mat-icon-button color="primary" (click)="onDeleteClick(item); $event.stopPropagation()">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </div>
</div>

<div *ngIf="!dataSource?.hasData()" fxLayout="row" fxLayoutAlign="center center">
    <p data-at-no-results>{{ 'COMMON.NO_RESULTS' | translate }}</p>
</div>

<div class="default-paginator" *ngIf="customPaginator">
    <button mat-icon-button (click)="goToFirstPage()" [disabled]="customPaginator.pageIndex === 0">
        <mat-icon>first_page</mat-icon>
    </button>
    <button mat-icon-button (click)="goToPreviousPage()" [disabled]="customPaginator.pageIndex === 0">
        <mat-icon>chevron_left</mat-icon>
    </button>
    <div class="paginator-pages">{{ customPaginator.pageIndex + 1 }}/{{ getTotalPages() }}</div>
    <button mat-icon-button (click)="goToNextPage()" [disabled]="customPaginator.pageIndex + 1 >= getTotalPages()">
        <mat-icon>chevron_right</mat-icon>
    </button>
    <button mat-icon-button (click)="goToLastPage()" [disabled]="customPaginator.pageIndex + 1 >= getTotalPages()">
        <mat-icon>last_page</mat-icon>
    </button>
</div>

<mat-paginator
    [length]="dataSource?.totalCount$ | async"
    [pageSize]="25"
    [pageSizeOptions]="[]"
    showFirstLastButtons
    hidePageSize
    #customPaginator
>
</mat-paginator>
